// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import packageJson from '../../package.json';

export const environment = {
  production: false,
  tag: 'dev',
  API_URL: 'https://api.cycling-365.dev.codigitalab.com',
  JWT_ALLOWED_DOMAINS: ['api.cycling-365.dev.codigitalab.com'],
  APP_URL: 'https://app.dev.cycling365.cc',
  version: packageJson.version,
};

export const MAPBOX_TOKEN = 'pk.eyJ1IjoiZGZhcmdhcyIsImEiOiJjbTlpZHJwbHQwMTEzMnFzOWdyMm1zYWlwIn0.Uan4TeELDEkcG3ppxC-8Jg';

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
